import React, { useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { Button, Image, Popconfirm } from "antd";
import cart from "../../assets/images/cart.png";
import { currencyFormat } from "../../lib/helpers/helpers";
import { currency } from "../../lib/helpers/currencySymbol";
import { ReactComponent as Del } from "../../assets/svg/del.svg";

const Wrapper = styled.div`
	${tw`flex flex-col md:flex-row gap-4 w-full p-2 bg-white! rounded-2xl`}
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	input {
		border: none !important;
	}

	/* Firefox */
	input[type="number"] {
		-moz-appearance: textfield;
	}
	.ant-input-number-input {
		${tw`border-none! focus:(ring-0 ring-transparent ring-opacity-0) hover:border-none`}
	}
`;

const CartItem = (props) => {
	const { item } = props;
	const [quantity, setQuantity] = useState(item.quantity);
	const remainingQuantity =
		item.shop_item.quantity_provided - item.shop_item.quantity_sold;
	const up = (i) => {
		if (quantity > 0 && quantity < remainingQuantity) {
			setQuantity(quantity + 1);
		}
	};
	const down = (i) => {
		if (quantity !== 1) {
			setQuantity(quantity - 1);
		}
	};

	console.log("cart item component", quantity);
	return (
		<Wrapper>
			<div tw="relative">
				<Image
					preview={false}
					src={item?.shop_item.shop_item_images[0]?.media_url || cart}
					alt={item.shop_item.name}
					width={180}
					height={195}
					// fallback={`data:image/png;base64,${fallback}`}
					tw="rounded-2xl shadow-md bg-gray-200 min-h-full min-w-full"
					placeholder={
						<Image
							preview={false}
							src={cart}
							width={180}
							height={195}
						/>
					}
				/>
			</div>
			<div tw="flex flex-col justify-between w-full gap-2">
				<div tw="flex flex-row w-full items-center gap-10">
					<p tw="mt-4 text-base font-semibold">
						{item.shop_item.name}
					</p>
					<Popconfirm
						placement="top"
						title={"Are you sure to delete this item?"}
						onConfirm={() => {
							// handleDelete(item?.id);
						}}
						okText="Yes"
						cancelText="No">
						<Del tw=" h-8 w-6  rounded-md hover:(shadow-md cursor-pointer)" />
					</Popconfirm>
				</div>
				<div tw="w-full">
					<p tw="text-base text-appTextFaded font-semibold">
						{item.shop_item.description}
					</p>
				</div>

				<div tw="flex flex-row gap-10  items-center">
					<p tw="text-base font-extrabold m-0!">
						{currency()} {currencyFormat(item.shop_item.price)}
					</p>

					<div tw="flex flex-row items-center justify-around">
						<div tw="inline-flex items-center justify-center">
							<Button
								tw="rounded-tl-md! rounded-bl-md! bg-gray-100 text-appPink font-bold"
								onClick={down}>
								-
							</Button>
							<input
								type="number"
								value={quantity}
								onChange={(e) => {
									if (e.target.value > remainingQuantity) {
										return;
									}
									setQuantity(e.target.value);
								}}
								tw="w-8 p-0 h-8 border-none! text-center cursor-default! text-appTextDark! bg-white! font-bold hover:(border-none)"
							/>

							<Button
								tw="rounded-tr-md! rounded-br-md! bg-appPink text-white font-bold "
								onClick={up}>
								+
							</Button>
						</div>
					</div>
				</div>
			</div>
		</Wrapper>
	);
};

export default CartItem;
